// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient__section {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.9) 50%,
    rgba(0, 0, 0, 0) 100%
  );
  position: fixed;
  top: 0;
  height: 25svh;
  width: 100vw;
  z-index: 100;
}

.about__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  color: white;
  align-items: center;
  justify-items: center;
  position: relative;
}

.about__Grid__test__left {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  height: 100svh;
  color: white;
  align-items: center;
  justify-items: center;
  position: sticky;
  top: 0;
  left: 0;
}

.about__Grid__test__right {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  height: -moz-fit-content;
  height: fit-content;
  color: white;
  align-items: center;
  justify-items: center;
  position: relative;
  bottom: 100svh;
  right: 0;
}

.about__Grid__left {
  grid-column: 1 / 3;
  height: clamp(100%, 100%, 100%);
  width: clamp(100%, 100%, 100%);
  align-self: self-start;
}

.about__Grid__right {
  grid-column: 1 / 3;
  justify-self: start;
  grid-column: 3 / 5;
  padding-top: 19em;
  padding-bottom: 0;
}

.about__Grid__right p {
  font-size: 20px;
  line-height: 25px;
  margin-top: 5%;
}

.team__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  justify-content: right;
  padding-top: 10svh;
  padding-bottom: 5svh;
}

.team__item {
  position: relative;
  width: clamp(150px, 100%, 100%);
}

.team-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px;
  text-align: left;
  font-size: 21px;
  font-weight: bolder;
  text-transform: lowercase;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  opacity: 0;
  pointer-events: none;
  z-index: 1; /* Set a higher z-index */
}

.team__item img {
  width: clamp(150px, 100%, 100%);
  height: auto;
}

.about__button__grid {
  display: grid;
  position: fixed;
  bottom: 0;
  height: 20svh;
  width: 100vw;
  z-index: 10;
  align-items: start;
  justify-content: center;
}

.about__navigation__button {
  color: white;
  cursor: pointer;
  font-size: 18px;
  font-weight: bolder;
}

.about__navigation__button img {
  max-width: 18.28px;
}

#About__Desktop {
  position: sticky;
  top: 19em;
}

.about__navigation__button img {
  margin: auto;
}

.about__navigation__button p {
  color: white;
  opacity: 50%;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5%;
}

.grid-container__footer__about {
  color: white;
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  margin-top: 2.5em;
  padding-bottom: 2.5em;
}

.footer__logos__test__about {
  grid-column: 1 / 2;
  display: flex;
  width: clamp(150px, 100%, 100%);
  align-items: end;
  justify-content: left;
  gap: 2em;
}

.footer__links__test__about {
  grid-column: 2 / 3;
  display: flex;
  justify-content: space-between;
  width: clamp(150px, 100%, 100%);
  align-items: end;
}

.footer__links__test__about p {
  font-size: 18px;
  opacity: 50%;
}

.grid-container__footer__about div {
  display: flex;
  align-items: last baseline;
}

.footer__logos__test__about img {
  max-height: 34px;
}

.teamInfo__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  padding-top: 2.5em;
  padding-bottom: 10.5em;
  color: white;
  position: relative;
}

.avatarIcon__Item {
  grid-column: 1 / 3;
  height: clamp(310px, 483px, 483px);
  width: clamp(310px, 483px, 483px);
  position: sticky;
  top: 12.5em;
}

.avatarIcon__Item img {
  height: clamp(310px, 483px, 483px);
  width: clamp(310px, 483px, 483px);
}

.teamInfo__Text__Item {
  grid-column: 3 / 5;
  padding-top: 12.5em;
}

.teamInfo__Text__Item h1 {
  font-size: 42px;
  font-weight: bolder;
  padding-bottom: 1rem;
}

.teamInfo__Text__Item h2 {
  font-size: 21px;
  font-weight: normal;
  opacity: 70%;
  padding-bottom: 1.5em;
}

.teamInfo__Text__Item p {
  font-size: 18px;
  font-weight: normal;
}

@media all and (min-width: 1921px) {
  .grid-container__footer__mobile {
    display: none !important;
  }

  #mobile__Info {
    display: none;
  }

  .grid-container__filter__mobile {
    display: none;
  }

  #About__Desktop {
    display: block;
  }

  #About__Mobile {
    display: none;
  }
}
@media all and (min-width: 1441px) and (max-width: 1920px) {
  .grid-container__footer__mobile {
    display: none !important;
  }

  #mobile__Info {
    display: none;
  }

  .grid-container__filter__mobile {
    display: none;
  }

  #About__Desktop {
    display: block;
  }

  #About__Mobile {
    display: none;
  }
}
@media all and (min-width: 1025px) and (max-width: 1440px) {
  .grid-container__footer__mobile {
    display: none !important;
  }

  #mobile__Info {
    display: none;
  }

  .grid-container__filter__mobile {
    display: none;
  }

  #About__Desktop {
    display: block;
  }

  #About__Mobile {
    display: none;
  }

  .about__Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 80%;
    color: white;
    align-items: center;
    justify-items: center;
  }

  .about__Grid__left {
    grid-column: 1 / 3;
    height: clamp(100%, 100%, 100%);
    width: clamp(100%, 100%, 100%);
    align-self: self-start;
  }

  .about__Grid__right {
    justify-self: start;
    grid-column: 3 / 5;
    padding-top: 19em;
    padding-bottom: 23.5em;
  }
}
@media all and (min-width: 769px) and (max-width: 1024px) {
  .grid-container__footer__about {
    display: none;
  }

  .about__Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 5svh;
    padding-bottom: 5svh;
    color: white;
    position: relative;
  }

  .about__Grid__left {
    grid-column: 1 / 3;
    width: clamp(100%, 100%, 100%);
    justify-self: end;
  }

  .about__Grid__right {
    grid-column: 1/ 3;
    width: clamp(100%, 100%, 100%);
    padding-top: 0;
    padding-bottom: 20svh;
    position: relative;
    top: 0;
  }

  .about__Grid__right p {
    font-size: 4vw;
    line-height: normal;
  }

  .team__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: right;
    padding-top: 0svh;
    padding-bottom: 5svh;
  }

  .about__button__grid {
    display: grid;
    position: fixed;
    bottom: 0;
    height: 25svh;
    width: 100vw;
    z-index: 10;
    align-items: center;
    justify-content: center;
  }

  .about__navigation__button {
    color: white;
    cursor: pointer;
    display: flex;
    margin: 0;
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
    position: static;
  }

  .navbar-container__test__Logo__about {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 2.5em;
    padding-bottom: 2em;
    position: sticky;
    top: 0;
    background-color: black;
    z-index: 20;
    align-content: center;
    align-items: center;
  }

  #About__Desktop {
    display: none;
  }

  #About__Mobile {
    display: block;
    height: clamp(189px, 100%, 100%);
    width: 100vw;
    padding-bottom: 1em;
  }

  .teamInfo__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 0em;
    padding-bottom: 2.5em;
    color: white;
    position: relative;
  }

  .avatarIcon__Item {
    grid-column: 1 / 3;
    height: clamp(310px, 100%, 100%);
    width: clamp(310px, 100%, 100%);
    position: initial;
    padding-top: 0;
  }

  .avatarIcon__Item img {
    height: auto;
    width: 100%;
  }

  .teamInfo__Text__Item {
    grid-column: 1 / 3;
    text-align: left;
    padding-top: 1em;
    padding-bottom: 0;
  }

  .teamInfo__Text__Item h1 {
    font-size: 24px;
  }

  .teamInfo__Text__Item h2 {
    padding-left: 0;
    padding-bottom: 1.5em;
    font-size: 18px;
    font-weight: normal;
  }

  .teamInfo__Text__Item p {
    font-size: 18px;
  }
}
@media all and (min-width: 426px) and (max-width: 768px) {
  .grid-container__footer__about {
    display: none;
  }

  .about__Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 5svh;
    padding-bottom: 5svh;
    color: white;
    position: relative;
  }

  .about__Grid__left {
    grid-column: 1 / 3;
    width: clamp(100%, 100%, 100%);
    justify-self: end;
  }

  .about__Grid__right {
    grid-column: 1/ 3;
    width: clamp(100%, 100%, 100%);
    padding-top: 0;
    padding-bottom: 20svh;
    position: relative;
    top: 0;
  }

  .about__Grid__right p {
    font-size: 4vw;
    line-height: normal;
  }

  .team__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: right;
    padding-top: 0svh;
    padding-bottom: 5svh;
  }

  .about__button__grid {
    display: grid;
    position: fixed;
    bottom: 0;
    height: 25svh;
    width: 100vw;
    z-index: 10;
    align-items: center;
    justify-content: center;
  }

  .about__navigation__button {
    color: white;
    cursor: pointer;
    display: flex;
    margin: 0;
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
    position: static;
  }

  .navbar-container__test__Logo__about {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 2.5em;
    padding-bottom: 2em;
    position: sticky;
    top: 0;
    background-color: black;
    z-index: 20;
    align-content: center;
    align-items: center;
  }

  #About__Desktop {
    display: none;
  }

  #About__Mobile {
    display: block;
    height: clamp(189px, 100%, 100%);
    width: 100vw;
    padding-bottom: 1em;
  }

  .teamInfo__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 0em;
    padding-bottom: 2.5em;
    color: white;
    position: relative;
  }

  .avatarIcon__Item {
    grid-column: 1 / 3;
    height: clamp(310px, 100%, 100%);
    width: clamp(310px, 100%, 100%);
    position: initial;
    padding-top: 0;
  }

  .avatarIcon__Item img {
    height: auto;
    width: 100%;
  }

  .teamInfo__Text__Item {
    grid-column: 1 / 3;
    text-align: left;
    padding-top: 1em;
    padding-bottom: 0;
  }

  .teamInfo__Text__Item h1 {
    font-size: 24px;
  }

  .teamInfo__Text__Item h2 {
    padding-left: 0;
    padding-bottom: 1.5em;
    font-size: 18px;
    font-weight: normal;
  }

  .teamInfo__Text__Item p {
    font-size: 18px;
  }
}
@media all and (min-width: 376px) and (max-width: 425px) {
  .grid-container__footer__about {
    display: none;
  }

  .about__Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 5svh;
    padding-bottom: 5svh;
    color: white;
    position: relative;
  }

  .about__Grid__left {
    grid-column: 1 / 3;
    width: clamp(100%, 100%, 100%);
    justify-self: end;
  }

  .about__Grid__right {
    grid-column: 1/ 3;
    width: clamp(100%, 100%, 100%);
    padding-top: 0;
    padding-bottom: 15svh;
    position: relative;
    top: 0;
  }

  .about__Grid__right p {
    font-size: 4vw;
    line-height: normal;
  }

  .team__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: right;
    padding-top: 0svh;
    padding-bottom: 5svh;
  }

  .about__button__grid {
    display: grid;
    position: fixed;
    bottom: 0;
    height: 20svh;
    width: 100vw;
    z-index: 10;
    align-items: center;
    justify-content: center;
  }

  .about__navigation__button {
    color: white;
    cursor: pointer;
    display: flex;
    margin: 0;
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
    position: static;
  }

  .navbar-container__test__Logo__about {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 2.5em;
    padding-bottom: 2em;
    position: sticky;
    top: 0;
    background-color: black;
    z-index: 20;
    align-content: center;
    align-items: center;
  }

  #About__Desktop {
    display: none;
  }

  #About__Mobile {
    display: block;
    height: clamp(189px, 100%, 100%);
    width: 100vw;
    padding-bottom: 1em;
  }

  .teamInfo__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 0em;
    padding-bottom: 2.5em;
    color: white;
    position: relative;
  }

  .avatarIcon__Item {
    grid-column: 1 / 3;
    height: clamp(310px, 100%, 100%);
    width: clamp(310px, 100%, 100%);
    position: initial;
    padding-top: 0;
  }

  .avatarIcon__Item img {
    height: auto;
    width: 100%;
  }

  .teamInfo__Text__Item {
    grid-column: 1 / 3;
    text-align: left;
    padding-top: 1em;
    padding-bottom: 0;
  }

  .teamInfo__Text__Item h1 {
    font-size: 24px;
  }

  .teamInfo__Text__Item h2 {
    padding-left: 0;
    padding-bottom: 1.5em;
    font-size: 18px;
    font-weight: normal;
  }

  .teamInfo__Text__Item p {
    font-size: 18px;
  }
}
@media all and (min-width: 321px) and (max-width: 375px) {
  .grid-container__footer__about {
    display: none;
  }

  .about__Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 5svh;
    padding-bottom: 5svh;
    color: white;
    position: relative;
  }

  .about__Grid__left {
    grid-column: 1 / 3;
    width: clamp(100%, 100%, 100%);
    justify-self: end;
  }

  .about__Grid__right {
    grid-column: 1/ 3;
    width: clamp(100%, 100%, 100%);
    padding-top: 0;
    padding-bottom: 15svh;
    position: relative;
    top: 0;
  }

  .about__Grid__right p {
    font-size: 4vw;
    line-height: normal;
  }

  .team__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: right;
    padding-top: 0svh;
    padding-bottom: 5svh;
  }

  .about__button__grid {
    display: grid;
    position: fixed;
    bottom: 0;
    height: 20svh;
    width: 100vw;
    z-index: 10;
    align-items: center;
    justify-content: center;
  }

  .about__navigation__button {
    color: white;
    cursor: pointer;
    display: flex;
    margin: 0;
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
    position: static;
  }

  .navbar-container__test__Logo__about {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 2.5em;
    padding-bottom: 2em;
    position: sticky;
    top: 0;
    background-color: black;
    z-index: 20;
    align-content: center;
    align-items: center;
  }

  #About__Desktop {
    display: none;
  }

  #About__Mobile {
    display: block;
    height: clamp(189px, 100%, 100%);
    width: 100vw;
    padding-bottom: 1em;
  }

  .teamInfo__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 0em;
    padding-bottom: 2.5em;
    color: white;
    position: relative;
  }

  .avatarIcon__Item {
    grid-column: 1 / 3;
    height: clamp(310px, 100%, 100%);
    width: clamp(310px, 100%, 100%);
    position: initial;
    padding-top: 0;
  }

  .avatarIcon__Item img {
    height: auto;
    width: 100%;
  }

  .teamInfo__Text__Item {
    grid-column: 1 / 3;
    text-align: left;
    padding-top: 1em;
    padding-bottom: 0;
  }

  .teamInfo__Text__Item h1 {
    font-size: 24px;
  }

  .teamInfo__Text__Item h2 {
    padding-left: 0;
    padding-bottom: 1.5em;
    font-size: 18px;
    font-weight: normal;
  }

  .teamInfo__Text__Item p {
    font-size: 18px;
  }
}
@media all and (max-width: 320px) {
  .grid-container__footer__about {
    display: none;
  }

  .about__Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 5svh;
    padding-bottom: 5svh;
    color: white;
    position: relative;
  }

  .about__Grid__left {
    grid-column: 1 / 3;
    width: clamp(100%, 100%, 100%);
    justify-self: end;
  }

  .about__Grid__right {
    grid-column: 1/ 3;
    width: clamp(100%, 100%, 100%);
    padding-top: 0;
    padding-bottom: 15svh;
    position: relative;
    top: 0;
  }

  .about__Grid__right p {
    font-size: 4vw;
    line-height: normal;
  }

  .team__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    justify-content: right;
    padding-top: 0svh;
    padding-bottom: 5svh;
  }

  .about__button__grid {
    display: grid;
    position: fixed;
    bottom: 0;
    height: 20svh;
    width: 100vw;
    z-index: 10;
    align-items: center;
    justify-content: center;
  }

  .about__navigation__button {
    color: white;
    cursor: pointer;
    display: flex;
    margin: 0;
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
    position: static;
  }

  .navbar-container__test__Logo__about {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 2.5em;
    padding-bottom: 2em;
    position: sticky;
    top: 0;
    background-color: black;
    z-index: 20;
    align-content: center;
    align-items: center;
  }

  #About__Desktop {
    display: none;
  }

  #About__Mobile {
    display: block;
    height: clamp(189px, 100%, 100%);
    width: 100vw;
    padding-bottom: 1em;
  }

  .teamInfo__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 0em;
    padding-bottom: 2.5em;
    color: white;
    position: relative;
  }

  .avatarIcon__Item {
    grid-column: 1 / 3;
    height: clamp(310px, 100%, 100%);
    width: clamp(310px, 100%, 100%);
    position: initial;
    padding-top: 0;
  }

  .avatarIcon__Item img {
    height: auto;
    width: 100%;
  }

  .teamInfo__Text__Item {
    grid-column: 1 / 3;
    text-align: left;
    padding-top: 1em;
    padding-bottom: 0;
  }

  .teamInfo__Text__Item h1 {
    font-size: 24px;
  }

  .teamInfo__Text__Item h2 {
    padding-left: 0;
    padding-bottom: 1.5em;
    font-size: 18px;
    font-weight: normal;
  }

  .teamInfo__Text__Item p {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/About.css"],"names":[],"mappings":"AAAA;EACE;;;;;GAKC;EACD,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EAIjB,cAAc;AAHhB;;AAMA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kCAA0B;UAA1B,0BAA0B;EAC1B,UAAU;EACV,oBAAoB;EACpB,UAAU,EAAE,yBAAyB;AACvC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IAEE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAElB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAElB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAElB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAElB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAElB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".gradient__section {\r\n  background: linear-gradient(\r\n    180deg,\r\n    rgba(0, 0, 0, 1) 0%,\r\n    rgba(0, 0, 0, 0.9) 50%,\r\n    rgba(0, 0, 0, 0) 100%\r\n  );\r\n  position: fixed;\r\n  top: 0;\r\n  height: 25svh;\r\n  width: 100vw;\r\n  z-index: 100;\r\n}\r\n\r\n.about__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  color: white;\r\n  align-items: center;\r\n  justify-items: center;\r\n  position: relative;\r\n}\r\n\r\n.about__Grid__test__left {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  height: 100svh;\r\n  color: white;\r\n  align-items: center;\r\n  justify-items: center;\r\n  position: sticky;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.about__Grid__test__right {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  height: fit-content;\r\n  color: white;\r\n  align-items: center;\r\n  justify-items: center;\r\n  position: relative;\r\n  bottom: 100svh;\r\n  right: 0;\r\n}\r\n\r\n.about__Grid__left {\r\n  grid-column: 1 / 3;\r\n  height: clamp(100%, 100%, 100%);\r\n  width: clamp(100%, 100%, 100%);\r\n  align-self: self-start;\r\n}\r\n\r\n.about__Grid__right {\r\n  grid-column: 1 / 3;\r\n  justify-self: start;\r\n  grid-column: 3 / 5;\r\n  padding-top: 19em;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.about__Grid__right p {\r\n  font-size: 20px;\r\n  line-height: 25px;\r\n}\r\n\r\n.about__Grid__right p {\r\n  margin-top: 5%;\r\n}\r\n\r\n.team__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  justify-content: right;\r\n  padding-top: 10svh;\r\n  padding-bottom: 5svh;\r\n}\r\n\r\n.team__item {\r\n  position: relative;\r\n  width: clamp(150px, 100%, 100%);\r\n}\r\n\r\n.team-title {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  color: white;\r\n  padding: 10px;\r\n  text-align: left;\r\n  font-size: 21px;\r\n  font-weight: bolder;\r\n  text-transform: lowercase;\r\n  backdrop-filter: blur(8px);\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  z-index: 1; /* Set a higher z-index */\r\n}\r\n\r\n.team__item img {\r\n  width: clamp(150px, 100%, 100%);\r\n  height: auto;\r\n}\r\n\r\n.about__button__grid {\r\n  display: grid;\r\n  position: fixed;\r\n  bottom: 0;\r\n  height: 20svh;\r\n  width: 100vw;\r\n  z-index: 10;\r\n  align-items: start;\r\n  justify-content: center;\r\n}\r\n\r\n.about__navigation__button {\r\n  color: white;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n}\r\n\r\n.about__navigation__button img {\r\n  max-width: 18.28px;\r\n}\r\n\r\n#About__Desktop {\r\n  position: sticky;\r\n  top: 19em;\r\n}\r\n\r\n.about__navigation__button img {\r\n  margin: auto;\r\n}\r\n\r\n.about__navigation__button p {\r\n  color: white;\r\n  opacity: 50%;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding-bottom: 5%;\r\n}\r\n\r\n.grid-container__footer__about {\r\n  color: white;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(320px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  margin-top: 2.5em;\r\n  padding-bottom: 2.5em;\r\n}\r\n\r\n.footer__logos__test__about {\r\n  grid-column: 1 / 2;\r\n  display: flex;\r\n  width: clamp(150px, 100%, 100%);\r\n  align-items: end;\r\n  justify-content: left;\r\n  gap: 2em;\r\n}\r\n\r\n.footer__links__test__about {\r\n  grid-column: 2 / 3;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: clamp(150px, 100%, 100%);\r\n  align-items: end;\r\n}\r\n\r\n.footer__links__test__about p {\r\n  font-size: 18px;\r\n  opacity: 50%;\r\n}\r\n\r\n.grid-container__footer__about div {\r\n  display: flex;\r\n  align-items: last baseline;\r\n}\r\n\r\n.footer__logos__test__about img {\r\n  max-height: 34px;\r\n}\r\n\r\n.teamInfo__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  padding-top: 2.5em;\r\n  padding-bottom: 10.5em;\r\n  color: white;\r\n  position: relative;\r\n}\r\n\r\n.avatarIcon__Item {\r\n  grid-column: 1 / 3;\r\n  height: clamp(310px, 483px, 483px);\r\n  width: clamp(310px, 483px, 483px);\r\n  position: sticky;\r\n  top: 12.5em;\r\n}\r\n\r\n.avatarIcon__Item img {\r\n  height: clamp(310px, 483px, 483px);\r\n  width: clamp(310px, 483px, 483px);\r\n}\r\n\r\n.teamInfo__Text__Item {\r\n  grid-column: 3 / 5;\r\n  padding-top: 12.5em;\r\n}\r\n\r\n.teamInfo__Text__Item h1 {\r\n  font-size: 42px;\r\n  font-weight: bolder;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.teamInfo__Text__Item h2 {\r\n  font-size: 21px;\r\n  font-weight: normal;\r\n  opacity: 70%;\r\n  padding-bottom: 1.5em;\r\n}\r\n\r\n.teamInfo__Text__Item p {\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n}\r\n\r\n@media all and (min-width: 1921px) {\r\n  .grid-container__footer__mobile {\r\n    display: none !important;\r\n  }\r\n\r\n  #mobile__Info {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: none;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: block;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: none;\r\n  }\r\n}\r\n@media all and (min-width: 1441px) and (max-width: 1920px) {\r\n  .grid-container__footer__mobile {\r\n    display: none !important;\r\n  }\r\n\r\n  #mobile__Info {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: none;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: block;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: none;\r\n  }\r\n}\r\n@media all and (min-width: 1025px) and (max-width: 1440px) {\r\n  .grid-container__footer__mobile {\r\n    display: none !important;\r\n  }\r\n\r\n  #mobile__Info {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: none;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: block;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: none;\r\n  }\r\n\r\n  .about__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 80%;\r\n    color: white;\r\n    align-items: center;\r\n    justify-items: center;\r\n  }\r\n\r\n  .about__Grid__left {\r\n    grid-column: 1 / 3;\r\n    height: clamp(100%, 100%, 100%);\r\n    width: clamp(100%, 100%, 100%);\r\n    align-self: self-start;\r\n  }\r\n\r\n  .about__Grid__right {\r\n    grid-column: 3 / 5;\r\n    justify-self: start;\r\n    grid-column: 3 / 5;\r\n    padding-top: 19em;\r\n    padding-bottom: 23.5em;\r\n  }\r\n}\r\n@media all and (min-width: 769px) and (max-width: 1024px) {\r\n  .grid-container__footer__about {\r\n    display: none;\r\n  }\r\n\r\n  .about__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 5svh;\r\n    padding-bottom: 5svh;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .about__Grid__left {\r\n    grid-column: 1 / 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    justify-self: end;\r\n  }\r\n\r\n  .about__Grid__right {\r\n    grid-column: 1/ 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    padding-top: 0;\r\n    padding-bottom: 20svh;\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n\r\n  .about__Grid__right p {\r\n    font-size: 4vw;\r\n    line-height: normal;\r\n  }\r\n\r\n  .team__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: right;\r\n    padding-top: 0svh;\r\n    padding-bottom: 5svh;\r\n  }\r\n\r\n  .about__button__grid {\r\n    display: grid;\r\n    position: fixed;\r\n    bottom: 0;\r\n    height: 25svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .about__navigation__button {\r\n    color: white;\r\n    cursor: pointer;\r\n    display: flex;\r\n    margin: 0;\r\n    width: fit-content;\r\n    text-align: center;\r\n    position: static;\r\n  }\r\n\r\n  .navbar-container__test__Logo__about {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 2.5em;\r\n    padding-bottom: 2em;\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: black;\r\n    z-index: 20;\r\n    align-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: none;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: block;\r\n    height: clamp(189px, 100%, 100%);\r\n    width: 100vw;\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .teamInfo__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 0em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .avatarIcon__Item {\r\n    grid-column: 1 / 3;\r\n    height: clamp(310px, 100%, 100%);\r\n    width: clamp(310px, 100%, 100%);\r\n    position: initial;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .avatarIcon__Item img {\r\n    height: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .teamInfo__Text__Item {\r\n    grid-column: 1 / 3;\r\n    padding-top: 12.5em;\r\n    text-align: left;\r\n    padding-top: 1em;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .teamInfo__Text__Item h1 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .teamInfo__Text__Item h2 {\r\n    padding-left: 0;\r\n    padding-bottom: 1.5em;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .teamInfo__Text__Item p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n@media all and (min-width: 426px) and (max-width: 768px) {\r\n  .grid-container__footer__about {\r\n    display: none;\r\n  }\r\n\r\n  .about__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 5svh;\r\n    padding-bottom: 5svh;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .about__Grid__left {\r\n    grid-column: 1 / 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    justify-self: end;\r\n  }\r\n\r\n  .about__Grid__right {\r\n    grid-column: 1/ 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    padding-top: 0;\r\n    padding-bottom: 20svh;\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n\r\n  .about__Grid__right p {\r\n    font-size: 4vw;\r\n    line-height: normal;\r\n  }\r\n\r\n  .team__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: right;\r\n    padding-top: 0svh;\r\n    padding-bottom: 5svh;\r\n  }\r\n\r\n  .about__button__grid {\r\n    display: grid;\r\n    position: fixed;\r\n    bottom: 0;\r\n    height: 25svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .about__navigation__button {\r\n    color: white;\r\n    cursor: pointer;\r\n    display: flex;\r\n    margin: 0;\r\n    width: fit-content;\r\n    text-align: center;\r\n    position: static;\r\n  }\r\n\r\n  .navbar-container__test__Logo__about {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 2.5em;\r\n    padding-bottom: 2em;\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: black;\r\n    z-index: 20;\r\n    align-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: none;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: block;\r\n    height: clamp(189px, 100%, 100%);\r\n    width: 100vw;\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .teamInfo__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 0em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .avatarIcon__Item {\r\n    grid-column: 1 / 3;\r\n    height: clamp(310px, 100%, 100%);\r\n    width: clamp(310px, 100%, 100%);\r\n    position: initial;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .avatarIcon__Item img {\r\n    height: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .teamInfo__Text__Item {\r\n    grid-column: 1 / 3;\r\n    padding-top: 12.5em;\r\n    text-align: left;\r\n    padding-top: 1em;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .teamInfo__Text__Item h1 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .teamInfo__Text__Item h2 {\r\n    padding-left: 0;\r\n    padding-bottom: 1.5em;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .teamInfo__Text__Item p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n@media all and (min-width: 376px) and (max-width: 425px) {\r\n  .grid-container__footer__about {\r\n    display: none;\r\n  }\r\n\r\n  .about__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 5svh;\r\n    padding-bottom: 5svh;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .about__Grid__left {\r\n    grid-column: 1 / 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    justify-self: end;\r\n  }\r\n\r\n  .about__Grid__right {\r\n    grid-column: 1/ 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    padding-top: 0;\r\n    padding-bottom: 15svh;\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n\r\n  .about__Grid__right p {\r\n    font-size: 4vw;\r\n    line-height: normal;\r\n  }\r\n\r\n  .team__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: right;\r\n    padding-top: 0svh;\r\n    padding-bottom: 5svh;\r\n  }\r\n\r\n  .about__button__grid {\r\n    display: grid;\r\n    position: fixed;\r\n    bottom: 0;\r\n    height: 20svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .about__navigation__button {\r\n    color: white;\r\n    cursor: pointer;\r\n    display: flex;\r\n    margin: 0;\r\n    width: fit-content;\r\n    text-align: center;\r\n    position: static;\r\n  }\r\n\r\n  .navbar-container__test__Logo__about {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 2.5em;\r\n    padding-bottom: 2em;\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: black;\r\n    z-index: 20;\r\n    align-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: none;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: block;\r\n    height: clamp(189px, 100%, 100%);\r\n    width: 100vw;\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .teamInfo__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 0em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .avatarIcon__Item {\r\n    grid-column: 1 / 3;\r\n    height: clamp(310px, 100%, 100%);\r\n    width: clamp(310px, 100%, 100%);\r\n    position: initial;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .avatarIcon__Item img {\r\n    height: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .teamInfo__Text__Item {\r\n    grid-column: 1 / 3;\r\n    padding-top: 12.5em;\r\n    text-align: left;\r\n    padding-top: 1em;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .teamInfo__Text__Item h1 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .teamInfo__Text__Item h2 {\r\n    padding-left: 0;\r\n    padding-bottom: 1.5em;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .teamInfo__Text__Item p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n@media all and (min-width: 321px) and (max-width: 375px) {\r\n  .grid-container__footer__about {\r\n    display: none;\r\n  }\r\n\r\n  .about__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 5svh;\r\n    padding-bottom: 5svh;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .about__Grid__left {\r\n    grid-column: 1 / 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    justify-self: end;\r\n  }\r\n\r\n  .about__Grid__right {\r\n    grid-column: 1/ 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    padding-top: 0;\r\n    padding-bottom: 15svh;\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n\r\n  .about__Grid__right p {\r\n    font-size: 4vw;\r\n    line-height: normal;\r\n  }\r\n\r\n  .team__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: right;\r\n    padding-top: 0svh;\r\n    padding-bottom: 5svh;\r\n  }\r\n\r\n  .about__button__grid {\r\n    display: grid;\r\n    position: fixed;\r\n    bottom: 0;\r\n    height: 20svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .about__navigation__button {\r\n    color: white;\r\n    cursor: pointer;\r\n    display: flex;\r\n    margin: 0;\r\n    width: fit-content;\r\n    text-align: center;\r\n    position: static;\r\n  }\r\n\r\n  .navbar-container__test__Logo__about {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 2.5em;\r\n    padding-bottom: 2em;\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: black;\r\n    z-index: 20;\r\n    align-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: none;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: block;\r\n    height: clamp(189px, 100%, 100%);\r\n    width: 100vw;\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .teamInfo__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 0em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .avatarIcon__Item {\r\n    grid-column: 1 / 3;\r\n    height: clamp(310px, 100%, 100%);\r\n    width: clamp(310px, 100%, 100%);\r\n    position: initial;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .avatarIcon__Item img {\r\n    height: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .teamInfo__Text__Item {\r\n    grid-column: 1 / 3;\r\n    padding-top: 12.5em;\r\n    text-align: left;\r\n    padding-top: 1em;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .teamInfo__Text__Item h1 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .teamInfo__Text__Item h2 {\r\n    padding-left: 0;\r\n    padding-bottom: 1.5em;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .teamInfo__Text__Item p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n@media all and (max-width: 320px) {\r\n  .grid-container__footer__about {\r\n    display: none;\r\n  }\r\n\r\n  .about__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 5svh;\r\n    padding-bottom: 5svh;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .about__Grid__left {\r\n    grid-column: 1 / 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    justify-self: end;\r\n  }\r\n\r\n  .about__Grid__right {\r\n    grid-column: 1/ 3;\r\n    width: clamp(100%, 100%, 100%);\r\n    padding-top: 0;\r\n    padding-bottom: 15svh;\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n\r\n  .about__Grid__right p {\r\n    font-size: 4vw;\r\n    line-height: normal;\r\n  }\r\n\r\n  .team__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    justify-content: right;\r\n    padding-top: 0svh;\r\n    padding-bottom: 5svh;\r\n  }\r\n\r\n  .about__button__grid {\r\n    display: grid;\r\n    position: fixed;\r\n    bottom: 0;\r\n    height: 20svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .about__navigation__button {\r\n    color: white;\r\n    cursor: pointer;\r\n    display: flex;\r\n    margin: 0;\r\n    width: fit-content;\r\n    text-align: center;\r\n    position: static;\r\n  }\r\n\r\n  .navbar-container__test__Logo__about {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 2.5em;\r\n    padding-bottom: 2em;\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: black;\r\n    z-index: 20;\r\n    align-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  #About__Desktop {\r\n    display: none;\r\n  }\r\n\r\n  #About__Mobile {\r\n    display: block;\r\n    height: clamp(189px, 100%, 100%);\r\n    width: 100vw;\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .teamInfo__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 0em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    position: relative;\r\n  }\r\n\r\n  .avatarIcon__Item {\r\n    grid-column: 1 / 3;\r\n    height: clamp(310px, 100%, 100%);\r\n    width: clamp(310px, 100%, 100%);\r\n    position: initial;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .avatarIcon__Item img {\r\n    height: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .teamInfo__Text__Item {\r\n    grid-column: 1 / 3;\r\n    padding-top: 12.5em;\r\n    text-align: left;\r\n    padding-top: 1em;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .teamInfo__Text__Item h1 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .teamInfo__Text__Item h2 {\r\n    padding-left: 0;\r\n    padding-bottom: 1.5em;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .teamInfo__Text__Item p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
